import React, { useEffect, useRef, useState } from "react";
import {fetchScrollPrices} from "../api"; // Ensure this API function is implemented

const PriceScroller = () => {
  const [prices, setPrices] = useState([]);
  const [isPaused, setIsPaused] = useState(false);
  const scrollerRef = useRef(null);
  const [scrollPosition, setScrollPosition] = useState(0);

  // Fetch stock price data
  useEffect(() => {
    const fetchPrices = async () => {
      try {
        const data = await fetchScrollPrices();
        // console.log('SCROLL DATA PRICES- > ',data)
        setPrices(data); // Ensure API returns an array of { symbol, price, change }
      } catch (error) {
        console.error("Error fetching stock prices:", error);
      }
    };

    fetchPrices();
    const interval = setInterval(fetchPrices, 15000); // Refresh prices every 15 seconds
    return () => clearInterval(interval);
  }, []);

  // console.log('SCROLL PRICES- > ',prices)

  // Auto-scroll logic
  useEffect(() => {
    let animationFrameId;

    const scrollContent = () => {
      if (!isPaused && scrollerRef.current) {
        setScrollPosition((prev) => {
          const newScrollPosition = prev - 1;
          const scrollWidth = scrollerRef.current.scrollWidth;
          const containerWidth = scrollerRef.current.offsetWidth;

          return Math.abs(newScrollPosition) >= scrollWidth - containerWidth
            ? 0
            : newScrollPosition;
        });
      }
      animationFrameId = requestAnimationFrame(scrollContent);
    };

    scrollContent();
    return () => cancelAnimationFrame(animationFrameId);
  }, [isPaused]);

  // Styles
  const styles = {
    container: {
      position: "relative",
      overflow: "hidden",
      backgroundColor: "#f5f5f5",
      border: "1px solid #e0e0e0",
      borderRadius: "8px",
      padding: "8px 0",
      boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
      width: "100%",
    },
    scroller: {
      display: "flex",
      transform: `translateX(${scrollPosition}px)`,
      whiteSpace: "nowrap",
      transition: isPaused ? "none" : "transform 0.1s linear",
    },
    priceItem: {
      display: "inline-block",
      padding: "0 16px",
      fontSize: "1rem",
      fontWeight: "bold",
      textDecoration: "none",
      cursor: "pointer",
    },
  };

  return (
    <div
      style={styles.container}
      onMouseEnter={() => setIsPaused(true)}
      onMouseLeave={() => setIsPaused(false)}
    >
      <div style={styles.scroller} ref={scrollerRef}>
        {prices.length > 0 ? (
          prices.map((stock, index) => (
            <span
              key={index}
              style={{
                ...styles.priceItem,
                color: stock.change_percent >= 0 ? "green" : "red",
              }}
            >
              {stock.symbol}: {stock.last_price} ({stock.change_percent > 0 ? "+" : ""}
              {stock.change_percent.toFixed(2)}%)
            </span>
          ))
        ) : (
          <span style={styles.priceItem}>Loading prices...</span>
        )}
      </div>
    </div>
  );
};

export default PriceScroller;
